import { render, staticRenderFns } from "./IconRightTop3.vue?vue&type=template&id=70d9a2cb&"
import script from "./IconRightTop3.vue?vue&type=script&lang=js&"
export * from "./IconRightTop3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d9a2cb')) {
      api.createRecord('70d9a2cb', component.options)
    } else {
      api.reload('70d9a2cb', component.options)
    }
    module.hot.accept("./IconRightTop3.vue?vue&type=template&id=70d9a2cb&", function () {
      api.rerender('70d9a2cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconRightTop3.vue"
export default component.exports